import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from '../../notifier';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import api from '../../../api/backend'

import CloseIcon from '@material-ui/icons/Close';
import MUIDataTable from "mui-datatables";

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

const styles = theme => ({
    addCourse: {
        marginBottom: 20
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    drawer: {
        width: 500
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
    submit: {
        marginTop: 20
    }
});

class New extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { show: false, loading: false, departments: [], courses: [], users: [] }
    }

    closeAndClear = () => {
        this.setState({ show: false, loading: false })
    }

    getDepartments = () => {
        api.getDepartments(false, true).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ departments: json })
            }
        }).catch(() => { })
    }

    getUsers = () => {
        api.getUsers(true).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ users: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากผุ้ใช้ทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    filterSubject = () => {
        const { department, departments } = this.state;
        if (department) {
            const found = departments.find((element) => {
                return element.id === department
            })

            if (found) {
                return found.subjects
            } else {
                return []
            }
        } else {
            return []
        }
    }

    filterCourse = () => {
        const { department, departments, subjectId } = this.state;
        if (subjectId) {
            const dep = departments.filter((element) => {
                return element.id === department
            })

            if (dep.length > 0) {
                const found = dep[0].subjects.find((e) => {
                    return e.id === subjectId
                })
                if (found) {
                    return found.courses
                } else {
                    return []
                }
            } else {
                return []
            }
        } else {
            return []
        }
    }

    componentDidMount() {
        this.getDepartments();
        this.getUsers();
    }
    

    countCreate = 0;
    register = (event) => {
        event.preventDefault();
        const { courseId, paymentStatus, type } = this.state
        const { onCreated } = this.props
        this.setState({ loading: true })
        this.countCreate = 0;
        this.userSelectedRows.forEach(e => {
            api.createMyCourse(courseId, { paymentStatus, user: e, type }).then(([response, json]) => {
                if (response.status === 200) {
                    this.setState({ paymentStatus: undefined, department: undefined, subjectId: undefined, courseId: undefined, type: undefined })
                    this.countCreate++
                    if (this.countCreate >= this.userSelectedRows.length) {
                        openSnackbar({ message: 'เพิ่มคอร์สสำเร็จ' })
                        this.setState({ loading: false });
                        if(onCreated) {
                            onCreated()
                        }
                    }
                } else {
                    this.countCreate++
                    console.error('ไม่สามารถเพิ่มคอร์สได้')
                    if (this.countCreate >= this.userSelectedRows.length) {
                        openSnackbar({ message: 'ไม่สามารถเพิ่มคอร์สได้' })
                        this.setState({ loading: false });
                    }
                }
            }).catch(() => {
                this.countCreate++
                console.error('ไม่สามารถเชื่อมต่อ service ได้')
                if (this.countCreate >= this.userSelectedRows.length) {
                    openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
                    this.setState({ loading: false });
                }
            })
        })
    }

    customToolbarSelect = (selectedRows) => {
        const newSelectedRow = selectedRows.data[selectedRows.data.length - 1]; // selectedRows.data.length > 1 ? selectedRows.data[1] : selectedRows.data[0];
        const newSelectedIndex = parseInt(newSelectedRow.index, 10);
        const temp = {
            data: newSelectedRow,
            lookup: {}
        };


        temp.lookup[`${newSelectedIndex}`] = true;
        //if (selectedRows.data.length > 1) {
        selectedRows.data = [];
        selectedRows.lookup = temp.lookup;
        selectedRows.data = temp.data; //selectedRows.data.push(temp.data);
        //}
    }

    userSelectedRows = []

    onRowsSelect = (x, allRowsSelected) => {
        const { users } = this.state
        console.log('allRowsSelected', allRowsSelected)
        let rows = []

        allRowsSelected.forEach(e => {
            rows.push(users[e.index].userName)
        });
        this.userSelectedRows = rows
    }

    validate = () => {
        const { courseId, paymentStatus, type } = this.state
        if (courseId && paymentStatus && type) {
            return true
        } else {
            return false
        }
    }

    render() {
        const { classes } = this.props
        const { loading, department, departments, users, subjectId, courseId, paymentStatus, type } = this.state
        return (
            <div>
                <Button onClick={() => this.setState({ show: true })}
                    variant="contained"
                    size="large"
                    color="primary"
                    fullWidth
                    className={classes.addCourse}
                >ลงทะเบียน</Button>

                <Dialog
                    open={this.state.show}
                    onClose={this.closeAndClear}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle id="form-dialog-title">ลงทะเบียน</DialogTitle>
                    <DialogContent>
                        <Notifier />
                        <Grid container spacing={24}>
                            <Grid item xs={6}>
                                <FormControl style={{ minWidth: 240 }} fullWidth>
                                    <InputLabel shrink htmlFor="demo-controlled-open-select">ชื่อกลุ่มวิชา</InputLabel>
                                    <Select
                                        value={department ? department : ''}
                                        onChange={(event) => {
                                            this.setState({ department: event.target.value, subjectId: undefined, courseId: undefined })
                                        }}
                                        inputProps={{
                                            name: 'department',
                                            id: 'department-simple',
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>กรุณาเลือก</em>
                                        </MenuItem>
                                        {departments.map(department => (
                                            <MenuItem key={department.id} value={department.id}>{department.title}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl style={{ minWidth: 240 }} fullWidth>
                                    <InputLabel shrink htmlFor="demo-controlled-open-select">ชื่อวิชา</InputLabel>
                                    <Select
                                        value={subjectId ? subjectId : ''}
                                        onChange={(event) => {
                                            this.setState({ subjectId: event.target.value, courseId: undefined })
                                        }}
                                        inputProps={{
                                            name: 'subject',
                                            id: 'subject-simple',
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>กรุณาเลือก</em>
                                        </MenuItem>
                                        {
                                            this.filterSubject().map(subject => (
                                                <MenuItem key={subject.id} value={subject.id}>{subject.title}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl style={{ minWidth: 240 }} fullWidth>
                                    <InputLabel shrink htmlFor="demo-controlled-open-select">คอร์ส</InputLabel>
                                    <Select
                                        value={courseId ? courseId : ''}
                                        onChange={(event) => { this.setState({ courseId: event.target.value }) }}
                                        inputProps={{
                                            name: 'course',
                                            id: 'course-simple',
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>กรุณาเลือก</em>
                                        </MenuItem>
                                        {
                                            this.filterCourse().map(course => (
                                                <MenuItem key={course.id} value={course.id}>{course.title}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} fullWidth required>
                                    <InputLabel shrink htmlFor="paymentStatus-helper">เลือกสถานะการชำระเงิน</InputLabel>
                                    <Select
                                        value={paymentStatus ? paymentStatus : ''}
                                        onChange={(event) => { this.setState({ paymentStatus: event.target.value }) }}
                                        input={<Input name="paymentStatus" id="paymentStatus-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="Inprogress">รอชำระ</MenuItem>
                                        <MenuItem value="Completed">ชำระแล้ว</MenuItem>
                                    </Select>
                                    <FormHelperText>เลือกสถานะการชำระเงิน</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl className={classes.formControl} fullWidth required>
                                    <InputLabel shrink htmlFor="type-helper">ประเภท</InputLabel>
                                    <Select
                                        value={type ? type : ''}
                                        onChange={(event) => { this.setState({ type: event.target.value }) }}
                                        input={<Input name="type" id="type-helper" required />}
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem value="เรียนออนไลน์">เรียนออนไลน์</MenuItem>
                                        <MenuItem value="เรียนออนไลน์+เรียนสด">เรียนออนไลน์+เรียนสด</MenuItem>
                                    </Select>
                                    <FormHelperText>ประเภทการเรียน</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <MUIDataTable
                                    title={""}
                                    data={users}
                                    columns={[
                                        {
                                            name: "firstName",
                                            label: "ชื่อ",
                                            options: {
                                                filter: true,
                                                sort: true,
                                            }
                                        },
                                        {
                                            name: "lastName",
                                            label: "นามสกุล",
                                            options: {
                                                filter: true,
                                                sort: true,
                                            }
                                        },
                                        {
                                            name: "tel",
                                            label: "เบอร์โทร",
                                            options: {
                                                filter: true,
                                                sort: true,
                                            }
                                        },
                                        {
                                            name: "userName",
                                            label: "ชื่อผู้ใช้งาน",
                                            options: {
                                                filter: true,
                                                sort: true,
                                            }
                                        },
                                    ]}
                                    options={
                                        {
                                            download: false,
                                            print: false,
                                            filter: false,
                                            // customToolbarSelect: this.customToolbarSelect,
                                            onRowsSelect: this.onRowsSelect
                                        }
                                    }
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeAndClear} color="default" disabled={loading}>
                            ปิด
                        </Button>
                        <Button onClick={this.register} color="primary" disabled={loading || !this.validate()}>
                            ลงทะเบียน
                        </Button>
                        {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : <React.Fragment>
                        </React.Fragment>}
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(styles)(New);